// can also be an array (or is it always an array?)
export const formatGraphQLError = (error: any) => error.graphQLErrors?.[0]?.message || ''
